import { combineReducers } from '@reduxjs/toolkit';
import api from '../api/api';

// reducers
import reportsDictionariesReducer from './dictionaries/slice';

// BALANCE
import balanceSheetReducer from '../hoc/balance/store/slices/sheet';
import balanceFrsReducer from '../hoc/balance/store/slices/frs';
import accountsReportReducer from '../hoc/balance/store/slices/accounts';

// PROFIT-LOSS
import profitLossSheetReducer from '../hoc/profit-loss/store/slices/sheet';
import profitLossFrsReducer from '../hoc/profit-loss/store/slices/frs';

// SAFEGUARDING
import safeguardingReducer from '../hoc/safeguarding/store/slice';

// CAPITAL ADEQUACY
import capitalAdequacyReducer from '../hoc/capital-adequacy/store/slice';

// BANK AND PSP
import bankAndPspReportReducer from '../hoc/bank-and-psp/store/slice';

// CURRENCIES POSITION
import currenciesPositionReducer from '../hoc/currency-position/store/slice';

// REVALUATIOIN
import revaluationReducer from '../hoc/revaluation/store/slice';

// TRANSACTIONS STATUS
import transactionsStatusReducer from '../hoc/transaction-status/store/slice';

// NOTIFICATION CENTER
import reportsNotificationCenterReducer from '../hoc/notification-center/store/slices';

// WARNINGS REPORT
import warningsReportReducer from '../hoc/warning-report/store/slice';

// ACCOUNTING MANAGMENT
import accountingManagmentReducer from '../hoc/accounting-managment/store/slice';

// FINTRAC
import fintracReducer from '../hoc/fintrac/store/slices/list';
import fintracReportReducer from '../hoc/fintrac/store/slices/report';

export const reducers = {
  reportsApi: api.reducer,
  reportsDictionaries: reportsDictionariesReducer,
  balance: combineReducers({
    sheet: balanceSheetReducer,
    frs: balanceFrsReducer,
    accountsReport: accountsReportReducer,
  }),
  profitLoss: combineReducers({
    sheet: profitLossSheetReducer,
    frs: profitLossFrsReducer,
  }),
  fintrac: combineReducers({
    list: fintracReducer,
    details: fintracReportReducer,
  }),
  safeguarding: safeguardingReducer,
  capitalAdequacy: capitalAdequacyReducer,
  bankAndPspReport: bankAndPspReportReducer,
  currenciesPosition: currenciesPositionReducer,
  revaluation: revaluationReducer,
  transactionsStatus: transactionsStatusReducer,
  reportsNotificationCenter: reportsNotificationCenterReducer,
  warningsReport: warningsReportReducer,
  accountingManagment: accountingManagmentReducer,
};

export const reportsApi = api;
